module.exports = "<template>\n    <section>\n        <b-progress :value=\"75\" size=\"is-medium\" show-value>\n            Custom display with <span style=\"color: red\">HTML</span>\n        </b-progress>\n        <b-progress :value=\"75\" size=\"is-medium\" show-value>\n            75 / 100\n        </b-progress>\n        <b-progress :value=\"75\" size=\"is-medium\" show-value>\n            3 out of 4\n        </b-progress>\n    </section>\n</template>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./docs/pages/components/progress/examples/ExSlot.vue
// module id = 1468
// module chunks = 25